// Base S3 bucket URL
const S3_BASE_URL = "https://jazr-public.s3.eu-central-1.amazonaws.com";

// Optional cache-busting version (change when update files)
const VERSION = "v1.0.0";

export const AWS_URLS = {
  IMPORT_ADJUSTMENTS: `${S3_BASE_URL}/Import-Adjustments.csv?v=${VERSION}`,
  IMPORT_ITEMS: `${S3_BASE_URL}/Import-Items.csv?v=${VERSION}`,
  IMPORT_STOCKTAKING: `${S3_BASE_URL}/Import-Stocktaking.csv?v=${VERSION}`,
  PURCHASING_EXCEL: `${S3_BASE_URL}/Purchasing-Excel.csv?v=${VERSION}`,
  MENU_PRODUCTS: `${S3_BASE_URL}/template-products-import.csv?v=${VERSION}`,
  MENU_MODIFIERS: `${S3_BASE_URL}/template-Modifier-import.csv?v=${VERSION}`,
  MENU_PRODUCT_RECIPE: `${S3_BASE_URL}/template-Product-Recipe.csv?v=${VERSION}`,
  MENU_MODIFIER_RECIPE: `${S3_BASE_URL}/template-Modifiers-Recipe.csv?v=${VERSION}`,
  PRODUCT_SALE_TEMPLATE: `${S3_BASE_URL}/product-sale-template.csv?v=${VERSION}`,
};
